import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

interface HeaderProps {
  onNavigate: (page: string) => void;
  currentPage: string;
}

export const Header: React.FC<HeaderProps> = ({ onNavigate, currentPage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'HOME', value: 'home' },
    { label: 'PRODUCTOS', value: 'plp' },
    { label: 'CONTACTO', value: 'contact' },
  ];

  return (
    <>
      <header className="sticky top-0 z-50 bg-[#061970]/80 backdrop-blur-md text-white shadow-lg">
        
        <div className="container mx-auto px-4 py-4 flex justify-between items-center relative lg:overflow-visible overflow-hidden">
          
          {/* Dynamic Background Element - Keeping subtle */}
          <div className="absolute top-0 right-0 w-1/3 h-full bg-[#459EDF] skew-x-[-15deg] transform translate-x-12 opacity-10 pointer-events-none" />

          {/* Logo */}
          <button 
            onClick={() => onNavigate('home')}
            className="relative z-10 block hover:opacity-90 transition-opacity"
          >
            <img 
              src="/header_mrc.png"
              alt="MRC Moto Racing" 
              className="h-8 md:h-10 w-auto object-contain"
            />
          </button>

          {/* Desktop Nav - Centered/Right balanced */}
          <nav className="hidden md:flex items-center gap-12 relative z-10">
            {navItems.map((item) => (
              <button
                key={item.value}
                onClick={() => onNavigate(item.value)}
                className={`text-sm font-bold tracking-widest hover:text-[#FF7F32] transition-colors uppercase italic ${currentPage === item.value ? 'text-[#FF7F32]' : 'text-gray-200'}`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden relative z-10">
            <button className="p-2" onClick={() => setMobileMenuOpen(true)}>
              <Menu className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Gradient Divider */}
        <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      </header>

      {/* Mobile Menu - Moved outside header to avoid stacking context issues */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed inset-0 z-[100] flex flex-col p-6 text-white"
            style={{ backgroundColor: '#061970' }}
          >
            <div className="flex justify-between items-center mb-8">
              <span className="font-black text-2xl italic text-[#FF7F32]">MENU</span>
              <button onClick={() => setMobileMenuOpen(false)}>
                <X className="w-8 h-8 text-white" />
              </button>
            </div>
            <nav className="flex flex-col gap-6">
              {navItems.map((item) => (
                <button
                  key={item.value}
                  onClick={() => {
                    onNavigate(item.value);
                    setMobileMenuOpen(false);
                  }}
                  className="text-2xl font-bold italic uppercase text-left hover:text-[#459EDF] transition-colors border-b border-[#459EDF]/30 pb-2"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
